import TickerSource from "../enum/TickerSource";

export default function(input){

    switch(input){

        case TickerSource.NOS_NEWS: return 'https://feeds.nos.nl/nosnieuwsalgemeen';

        default: return null;
    }
}